import t from "@ext/localization/locale/translate";
import { Button } from "@ui-kit/Button";
import { PopoverContent } from "@ui-kit/Popover";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import type { ComponentProps, ReactNode } from "react";

export const DiffLinePopoverContent = (props: ComponentProps<typeof PopoverContent>) => (
	<PopoverContent
		align="start"
		alignOffset={8}
		className="w-[400px] max-w-[var(--radix-popover-content-available-width)] overflow-hidden p-0"
		onCloseAutoFocus={(event) => event.preventDefault()}
		onOpenAutoFocus={(event) => event.preventDefault()}
		side="top"
		sideOffset={8}
		{...props}
	/>
);

export const DiffLinePopoverHeader = ({ title, action }: { title: string; action?: ReactNode }) => (
	<div className="flex min-h-8 items-center justify-between gap-2 px-3 pt-2">
		<span className="text-xs font-medium uppercase tracking-wide text-muted">{title}</span>
		{action}
	</div>
);

export const DiscardButton = ({ onClick, qa }: { onClick?: () => void; qa: string }) => (
	<Tooltip>
		<TooltipTrigger asChild>
			<Button data-qa={qa} onClick={onClick} size="xs" startIcon="reply" variant="text">
				{t("diff.discard")}
			</Button>
		</TooltipTrigger>
		<TooltipContent>{t("git.discard.paragraph-tooltip")}</TooltipContent>
	</Tooltip>
);
